<template>
  <div>
    <i
      class="fa fa-spin fa-circle-o-notch"
      v-if="loading"
    />
    <div v-else>
      <p class="m-t-15 m-b-15">
        <span v-if="integration.id">
          {{ __('Integração configurada. Caso queira alterar') }} <a
            href="#"
            @click.prevent="updating = !updating"
          >{{ __('clique aqui') }}</a>.
        </span>
        <span v-else>
          {{ __('Para configurar a integração com a Plug CRM adicione seu token abaixo e clique em salvar') }}.
        </span>
      </p>

      <form
        @submit.prevent="save()"
        v-if="!integration.id || updating"
      >
        <div class="row">
          <div class="col-md-5">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="config.token"
                :placeholder="tokenPlaceholder"
              >

              <div class="input-group-append">
                <button
                  type="submit"
                  class="btn btn-box border-left-0"
                  :disabled="disabled"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>

        <p class="m-t-5 m-b-15">
          {{ __('O token deve ser gerado no sistema Plug CRM, em') }} <a
            href="https://plugcrm.net/app/#/settings/profile"
            target="_blank"
          >{{ __('Perfil') }}</a> <i class="fa fa-angle-double-right" /> Token da instância.
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import Integrations from '../../mixins/integrations';

export default {
  mixins: [Integrations],

  data () {
    return {
      integration: {
        name: 'plug',
      },
    };
  },
};
</script>
